export default __webpack_public_path__ + "06d67165f08dec822877e0d9fbe658f1.png";